import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { GeoReportStatusResponse } from '../../../models/geo-report/GeoReportResponse';
import { getGeoReportStatus } from '../../../services/geo-report/GeoReportService';
import { GET_GEO_REPORT_STATUS, GET_GEO_REPORTS } from '../../query/geo-report/keys';

interface UseGeoReportStatusPollParams {
  id: number | null;
  status: 'PENDING' | 'GENERATING' | 'COMPLETED' | 'FAILED' | null;
}

export const useGeoReportStatusPoll = ({ id, status }: UseGeoReportStatusPollParams) => {
  const queryClient = useQueryClient();
  const isPolling = status === 'PENDING' || status === 'GENERATING';

  const { data } = useQuery<GeoReportStatusResponse>({
    queryKey: [GET_GEO_REPORT_STATUS, id],
    queryFn: () => getGeoReportStatus(id!),
    enabled: !!id && isPolling,
    refetchInterval: isPolling ? 5000 : false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data?.status === 'COMPLETED' || data?.status === 'FAILED') {
      queryClient.invalidateQueries({ queryKey: [GET_GEO_REPORTS] });
    }
  }, [data?.status, queryClient]);

  return { data };
};